module.exports = __webpack_public_path__ + "static/media/gy.79fcf270.svg";